// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"846":"203b0e0d","850":"0d60ac9a"}[chunkId] + ".chunk.js";
};